import { SHIPPING_ACTION_TYPES } from "./actionTypes";

const initialState = {
    loading: false,
    error: null,

    address: {
        fullAddress: '',
        city: '',
        postalCode: '',
        region: '',
        stateCode: '',
        street: '',
        house: '',
        flat: '',
        fiasId: '',
        geoLat: null,
        geoLon: null,
    },

    shippingOptions: {},
    minDelivery: null,
    minPickup: null,
    cacheKey: null,

    selectedOption: null,

    pickupPoints: [],
    pickupPointsLoading: false,
    pickupPointsError: null,
    selectedPickupPoint: null,

    lastUpdated: null,
};

export const shippingReducer = (state = initialState, action) => {
    switch (action.type) {
        case SHIPPING_ACTION_TYPES.CALCULATE_REQUEST: {
            return {
                ...state,
                loading: true,
                error: null,
            };
        }

        case SHIPPING_ACTION_TYPES.CALCULATE_SUCCESS: {
            const { shippingOptions, minDelivery, minPickup, cacheKey } = action.payload;

            return {
                ...state,
                loading: false,
                error: null,
                shippingOptions,
                minDelivery,
                minPickup,
                cacheKey,
                lastUpdated: action.meta.timestamp,
            };
        }

        case SHIPPING_ACTION_TYPES.CALCULATE_FAILURE: {
            return {
                ...state,
                loading: false,
                error: action.payload.error,
                shippingOptions: {},
                minDelivery: null,
                minPickup: null,
            };
        }

        case SHIPPING_ACTION_TYPES.SET_SELECTED_OPTION: {
            return {
                ...state,
                selectedOption: action.payload.optionKey,
                selectedPickupPoint: null,
                pickupPoints: [],
                pickupPointsLoading: false,
                pickupPointsError: null,
            };
        }

        case SHIPPING_ACTION_TYPES.SET_ADDRESS: {
            const { address } = action.payload;

            return {
                ...state,
                address: {
                    fullAddress: address.fullAddress || address.value || '',
                    city: address.city || '',
                    postalCode: address.postalCode || '',
                    region: address.region || '',
                    stateCode: address.stateCode || '',
                    street: address.street || '',
                    house: address.house || '',
                    flat: address.flat || '',
                    fiasId: address.fiasId || '',
                    geoLat: address.geoLat || null,
                    geoLon: address.geoLon || null,
                },
                shippingOptions: {},
                minDelivery: null,
                minPickup: null,
                selectedOption: null,
            };
        }

        case SHIPPING_ACTION_TYPES.CLEAR_ADDRESS: {
            return {
                ...state,
                address: initialState.address,
                shippingOptions: {},
                minDelivery: null,
                minPickup: null,
                selectedOption: null,
            };
        }

        case SHIPPING_ACTION_TYPES.FETCH_PICKPOINTS_REQUEST: {
            return {
                ...state,
                pickupPointsLoading: true,
                pickupPointsError: null,
            };
        }

        case SHIPPING_ACTION_TYPES.FETCH_PICKPOINTS_SUCCESS: {
            return {
                ...state,
                pickupPointsLoading: false,
                pickupPoints: action.payload.points,
            };
        }

        case SHIPPING_ACTION_TYPES.FETCH_PICKPOINTS_FAILURE: {
            return {
                ...state,
                pickupPointsLoading: false,
                pickupPointsError: action.payload.error,
            };
        }

        case SHIPPING_ACTION_TYPES.SELECT_PICKUP_POINT: {
            return {
                ...state,
                selectedPickupPoint: action.payload.point,
            };
        }

        case SHIPPING_ACTION_TYPES.RESET_SHIPPING: {
            return initialState;
        }

        default:
            return state;
    }
};